/**
 * Identificativi dei template certificato per corsi pro (mapping per course id in courseCertificationDetails).
 */
export const CERTIFICATE_TEMPLATE_IDS = ['cert1', 'cert2', 'cert3'] as const;

export type CertificateTemplateId = (typeof CERTIFICATE_TEMPLATE_IDS)[number];

export const DEFAULT_CERTIFICATE_TEMPLATE_ID: CertificateTemplateId = 'cert3';
